import { declareTheme } from "@component-library/themes";

export const useTheme = declareTheme({
  default: {
    container: 'min-h-9 h-9 text-sm gap-3',
    label: 'pl-3 pr-1',
    menu: 'pr-2',
    icon: 'base' as const,
    button: {
      base: 'px-3',
      enabled: 'hover:bg-neutral-150 text-neutral-950'
    }
  },
  editor: {
    container: 'min-h-6 h-6 text-xs font-medium gap-1.5',
    label: 'px-1',
    menu: '',
    icon: 'xs' as const,
    button: {
      base: 'px-1',
      enabled: 'hover:bg-primary-150 hover:text-primary-500 text-neutral-500'
    }
  }
})